<!-- 承诺书对话框 -->
<template>
    <el-dialog  v-model="showDialog"   @open="handleOpen" title="承诺书"  class="diglog" width="90%"  center :lock-scroll="false"><!-- 子组件维护对话框显隐 -->
        <template #header="{ close, titleId, titleClass }">
            <div class="my-header">
                <h4 style="font-size: 0.5rem; text-align: right;vertical-align: text-top;">ver 1.00</h4>
                <h4 :id="titleId" :class="titleClass"  style="font-size: 2rem; color: #0D2EA0;">承诺书</h4>
            </div>
        </template>
        <el-scrollbar height="25rem">
        <div>			
			<p class="fontCss">
                1.	本人将恪守诚信并确认我所提供的个人简历、证件复印件等所有资料真实、无误；
            </p>
            <p class="fontCss">
                2.	本人按照公司要求提供个人资料（包含但不限于身份证复印件、学历证书复印件、原用人单位的离职证明等相关资料），否则，公司可视为本人不符合公司的录用条件；			
            </p>	
            <p class="fontCss">
                3.	本人向公司出示的、提交的、陈述的任何有关本人的信息说明及相关证件复印件都是真实的，否则视为本人的欺诈行为，公司可以据此严重违反公司规章制度解除与本人的劳动合同，并且不负担任何赔偿责任。因本人的不诚信行为给公司造成的损害，由本人承担：			
            </p>	
            <p class="fontCss">
                4.	本人提供的原用人单位离职证明真实有效，本人愿意承担因离职证明虚假而引起的所有经济责任（包含但不限于对原工作单位及公司的经济赔偿）与法律责任；
            </p>	
            <p class="fontCss">
                5.	本人现与其他任何单位不存在劳动关系。本人受聘贵公司不会违反本人对前雇主任何竞业限制义务，公司不会因雇佣本人而引发任何诉讼。
若因公司雇佣本人而引发任何法律责任由本人承担；
            </p>	
            <p class="fontCss">
                6.	本人在应聘、面试及入职手续办理过程中，没有受到虚假招聘宣传、就业歧视（包含但不限于性别、地域、民族、身高与乙肝歧视）及其他不公正的待遇；
            </p>	
            <p class="fontCss">
                7.	本人承诺在职期间没有任何形式的兼职，不直接、间接或变相从事或经营与公司相同或相近的业务；
            </p>	
            <p class="fontCss">
                8.	本人承诺同意按照公司日历卡或最新出勤调整通知出勤；	

            </p>	
            <p class="fontCss">
                9.	本人承诺遵守国家的法律法规及公司规章制度；
            </p>	
            <p class="fontCss">
                10.	本承诺书与《劳动合同》具有同等法律效力。
            </p>	
            <p class="fontCss">
            以上承诺内容为本人自愿、独立、真实的意愿表示。			

            </p>		
            </div>
        </el-scrollbar>
        <template #footer>
            <span class="dialog-footer">
                <el-button type="primary"  style="float: none; width: 120px;" @click="showDialog = false">
                确定
                </el-button>
            </span>
        </template>
        
        <!-- <el-button @click="$emit('confirm','123123')">Confirm</el-button> -->
    </el-dialog>
</template>
<script>
 export default {
    data() {
        return {
            showDialog: false,
        }
    },
    methods: {
        show(){
            this.showDialog = true;
            this.$nextTick(()=> {
                // this.$refs.table.query() // el-dialog懒渲染，需要使用nextTick初始化数据
            });
        },
        handleOpen(){ // 由于el-dialog懒渲染，或使用官方提供的open回调
            //this.$refs.table.query() // 这样，第一次打开就能获取到this.$refs.的内容了
        }
    }
}
</script>
<style lang="scss" scoped>
    .fontCss{
        line-height: 1.2rem;
        font-size: 1.2rem;
        padding: 5px 0;
        text-indent:2rem;
    }
</style>